import React, { useState, useEffect, useCallback } from "react";
import { CheckUI } from "./styles";
import { privilegios } from "../../../../utils/Utils";
import swal from "sweetalert";
import { producaov2 } from "../../../../services/apis";
const CheckBoxes = (props) => {
  const [permissoes, setPermissoes] = useState({});
  const [admin, setAdmin] = useState(false);
  const [privGod, setPrivGod] = useState(false);

  useEffect(() => {
    loadPermissoes();
  }, []);

  const loadPermissoes = useCallback(() => {
    try {
      const startPermissoes = {};
      privilegios().map((privilegio) => {
        startPermissoes[privilegio.value] = props.permissoes.permissao.includes(
          privilegio.value
        );
      });
      startPermissoes["EDIT_PRIV_GOD_MOD"] = props.permissoes.permissao
        .split(",")
        .map((permissao) => permissao.trim())
        .includes("EDIT_PRIV_GOD_MOD");
      setPermissoes(startPermissoes);
      setPrivGod(startPermissoes["EDIT_PRIV_GOD_MOD"]);
      setAdmin(true);
    } catch (err) {
      console.log("ERROR", err);
      setAdmin(false);
    }
  }, [props.permissoes]);

  const handleCheck = useCallback(
    (e) => {
      const objRegister = {
        ip: null,
        nome: props.aluno.name,
        email: props.aluno.email,
        ativo: "S",
        privilegio: "*",
        ultimo_acesso: null,
        
    }
    console.log(objRegister);
      const { name } = e.target;
      const newPermissoes = { ...permissoes };
      producaov2.post (`/usuario`, objRegister )
      .then(async (res) => {
        let array = { local: "usuario", texto: `criou o usuario de id=${res.data.id}` };
        await producaov2.post("system_logs", { acao: JSON.stringify(array) });
        
      }).catch(err => {
        console.log(err);
        swal("Não foi possível criar o usuario", "", "error");
      }
      );

      if (name == "EDIT_PRIV_GOD_MOD") {
        setPrivGod(e.target.checked);
      }

      newPermissoes[name] = !newPermissoes[name];
      console.log("handlecheck", newPermissoes);
      setPermissoes(newPermissoes);
      props.handlePermissoes(newPermissoes);
    },
    [permissoes]
  );

  return (
    <>
      <CheckUI>
        {" "}
        <label>
        Privilegios: 
          <input
            type="checkbox"
            name="Admin"
            checked={admin}
            onClick={(e) => {
              props.handleAdmin(e.target.checked);
              setAdmin(e.target.checked);
              handleCheck(e);
            }}
          />
          É administrador?
        </label>{" "}
      </CheckUI>
     {/* Não estavamos utilizando as permissões, vamos adota-las em breve!
      <CheckUI>
        {" "}
        <label>
          Privilegios:
          <input
            type="checkbox"
            name="EDIT_PRIV_GOD_MOD"
            checked={privGod}
            onClick={handleCheck}
            disabled={!admin}
          />
          Modificar privilégios
        </label>
      </CheckUI>

      {privilegios().map((privilegio) => {
        return (
          <CheckUI>
            {" "}
            <label>
              <input
                type="checkbox"
                name={privilegio.value}
                checked={permissoes[privilegio.value]}
                onClick={handleCheck}
                disabled={!privGod}
              />
              {privilegio.label}
            </label>{" "}
          </CheckUI>
        );
      })} */}
    </>
  );
};

export default CheckBoxes;
